var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-24-/-Outline-/-Places-/-business_main_",
    transform: "translate(-2.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: -5.00000006e-8,
    y: -5.00000006e-8,
    width: 24.0000001,
    height: 24.0000001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,3.99999997 L20,20 L18,20 L18,16 L12,16 L12,20 L9.99999999,20 L9.99999999,3.99999997 L20,3.99999997 M22,1.99999996 L7.99999996,1.99999996 L7.99999996,20 L3.99999996,20 L3.99999996,18 L5.99999996,18 L5.99999996,16 L3.99999996,16 L3.99999996,14 L5.99999996,14 L5.99999996,12 L3.99999996,12 L3.99999996,9.99999996 L5.99999996,9.99999996 L5.99999996,7.99999996 L3.99999996,7.99999996 C2.89543046,7.99999996 1.99999996,8.89543049 1.99999996,9.99999996 L1.99999996,22 L14,22 L14,18 L16,18 L16,22 L22,22 L22,1.99999996 Z M14,5.99999998 L12,5.99999998 L12,8.99999998 L14,8.99999998 L14,5.99999998 Z M18,5.99999998 L16,5.99999998 L16,8.99999998 L18,8.99999998 L18,5.99999998 Z M14,11 L12,11 L12,14 L14,14 L14,11 Z M18,11 L16,11 L16,14 L18,14 L18,11 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fillOpacity: 0.8,
    fill: "#000A19",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryAddress);
export default __webpack_public_path__ + "static/media/delivery-address.79b5357b546cd4bdda1d6499f984b603.svg";
export { ForwardRef as ReactComponent };